import * as Sentry from "@sentry/react";

const normalizeError = (error) => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === "string") {
    return new Error(error);
  }

  return new Error("Unknown application error");
};

export const captureAppError = (error, context = {}) => {
  const normalizedError = normalizeError(error);
  Sentry.withScope((scope) => {
    if (context.tags) {
      Object.entries(context.tags).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          scope.setTag(key, String(value));
        }
      });
    }

    if (context.extra) {
      Object.entries(context.extra).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }

    if (context.level) {
      scope.setLevel(context.level);
    }

    Sentry.captureException(normalizedError);
  });
};
